import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { commonBenefits } from '@/mocks/benefitsData';

const badgeImage = '/images/generated/benefits-badge-2026.jpg';

export default function CommonBenefits() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('benefits.common.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('benefits.common.title')}
          </h2>
          {String(t('benefits.common.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">
            {lang === 'en' ? t('benefits.common.lead') : commonBenefits.lead}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 items-start">
          <div className="flex-1 space-y-6">
            {commonBenefits.items.map((item, idx) => (
              <div
                key={idx}
                className="flex items-start gap-4 bg-primary-800/50 p-5"
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-accent-500/15 rounded-full">
                  <i className={`${item.icon} text-accent-400 text-base`}></i>
                </div>
                <div>
                  <h3 className="text-[16px] text-foreground-50 tracking-[0.05em] font-medium mb-1">
                    {lang === 'en' ? t(`benefits.common.item.${idx}.name`) : item.name}
                  </h3>
                  <p className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed">
                    {lang === 'en' ? t(`benefits.common.item.${idx}.desc`) : item.description}
                  </p>
                </div>
              </div>
            ))}
            {String(t('benefits.common.certNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] leading-relaxed pt-2">{__s}</p>))}
          </div>

          <div className="w-full lg:w-[320px] flex-shrink-0">
            <div className="relative h-[280px] overflow-hidden">
              <img
                src={badgeImage}
                alt={t('benefits.common.badgeImgAlt')}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                {String(t('benefits.common.badgeCaption')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-50/90 tracking-[0.05em]">{__s}</p>))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
